<div class="alinhamento-tela">
  <app-titulo [titulo]="'Documentos'"></app-titulo>

  @if (width < 768) {
    <div class="flex-row-reverse gap-5" style="margin-bottom: 10px" (click)="limparFiltro()">
      <button mat-flat-button class="btn-limpar">
        <mat-icon>cleaning_services</mat-icon>
      </button>

      <button mat-flat-button class="btn-filtro" (click)="abrirModalFiltro()">
        <mat-icon>filter_list</mat-icon>
        <span class="font-12 weight-700">Filtrar</span>
      </button>
    </div>
  } @else {
    <div class="area-filtros" [formGroup]="filtro">
      <mat-form-field appearance="outline">
        <mat-label>Todas as Coligadas</mat-label>
        <mat-select formControlName="coligada" ngDefaultControl>
          <mat-option [value]="null">Selecione...</mat-option>
          @for (coligada of coligadas; track coligada.id) {
            <mat-option [value]="coligada">{{ coligada.id }} - {{ coligada.nome }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Tipo de Documento</mat-label>
        <mat-select formControlName="tipoDocumento" ngDefaultControl>
          <mat-option [value]="null">Selecione...</mat-option>
          @for (tipoDocumento of tiposDocumentos; track tipoDocumento.id) {
            <mat-option [value]="tipoDocumento">{{ tipoDocumento.nome }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Data</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate formControlName="dataInicial" placeholder="Data Inicial">
          <input matEndDate formControlName="dataFinal" placeholder="Data Final">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Parceiro</mat-label>
        <mat-select formControlName="parceiro" ngDefaultControl>
          <mat-option [value]="null">Selecione...</mat-option>
          @for (parceiro of parceiros; track parceiro.id) {
            <mat-option [value]="parceiro">{{ parceiro.nome }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-checkbox
        formControlName="agruparPorTipo"
        style="align-self: center"
        (change)="agruparDocumentos()">
        Exibir listagem por tipo
      </mat-checkbox>
    </div>
  }

  <div class="flex-row gap-30">
    <div class="area-historico">
      <div style="overflow: auto; height: 100%">
        @for (map of mapDocumentos; track map[0]) {
          <div class="flex-row align-center justify-btw">
            <span class="weight-700 font-12 color-azul">{{ map[0] }}</span>
            <div class="flex-row align-center justify-center gap-9" style="color: white; background-color: #5EB7C3; padding: 4px 8px; border-radius: 3px">
              <mat-icon class="font-13" style="height: 13px; width: 12px;">description</mat-icon>
              <span class="weight-700 font-9">{{ getQuatidadeDocumento(map[1]) }}</span>
            </div>
          </div>

          @for (mapEmpresa of map[1]; track mapEmpresa[0]) {
            <div class="flex-column gap-14" style="padding: 9px 17px; border-left: 1px solid #E6E3E3; margin-left: 5px">
              <div class="flex-row align-center gap-8">
                <div [style.background-color]="getCor(mapEmpresa[0])" style="height: 18px; width: 18px; border-radius: 3px;"></div>
                <span class="font-11 weight-700 color-cinza">{{ mapEmpresa[0] }}</span>
              </div>

              @for (doc of mapEmpresa[1]; track doc) {
                <div class="flex-row align-center justify-btw cursor-pointer" (click)="selecionarDocumento(doc)"
                     [style.background-color]="verificarDocSelecionado(doc) ? '#BDD6D9' : ''" style="padding: 1px 5px">
                  <div class="flex-column" style="width: 60%">
                    <div class="flex-row gap-2">
                      <span class="font-11 weight-400 color-cinza" style="white-space: nowrap">Parceiro: </span>
                      <span class="font-11 weight-700 ellipse color-cinza">{{ doc.parceiro ? doc.parceiro : 'Todos' }}</span>
                    </div>

                    <div class="flex-row gap-2">
                      <span class="font-11 weight-400 color-cinza" style="white-space: nowrap">Tipo de Documento: </span>
                      <span class="font-11 weight-700 ellipse color-cinza">{{ doc.tipoDocumento }}</span>
                    </div>

                    <div class="flex-row align-center" style="padding: 2px 10px; border-left: 1px solid #E6E3E3; margin-left: 5px;">
                      <mat-icon>description</mat-icon>
                      <span class="font-11 weight-400 ellipse color-cinza">{{ doc.nomeArquivo }}.{{ doc.extensaoArquivo }}</span>
                    </div>
                  </div>

                  <div class="flex-column">
                    <div class="flex-row align-center gap-5">
                      <mat-icon class="font-17 color-azul">date_range</mat-icon>
                      <span class="font-10 weight-400 color-cinza">{{ doc.data | date: 'dd/MM/yyyy HH:mm' }}</span>
                    </div>

                    <div class="flex-row align-center gap-5" style="margin-top: -5px">
                      <mat-icon class="font-17 color-azul">person</mat-icon>
                      <span class="font-10 weight-400 color-cinza">{{ doc.usuarioEnvio }}</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        }
      </div>
    </div>

    @if (documentoSelecionado) {
      <div class="area-documento">
        <div class="flex-column gap-9">
          <div class="flex-row gap-5 align-center">
            <mat-icon>description</mat-icon>
            <span class="font-11 weight-700 color-cinza">{{ documentoSelecionado.nomeArquivo }}.{{ documentoSelecionado.extensaoArquivo }}</span>
          </div>

          <div class="flex-column">
            <span class="font-9 weight-400 color-cinza">Tipo</span>
            <span class="font-10 weight-700 color-cinza">{{ documentoSelecionado.tipoDocumento }}</span>
          </div>

          <div class="flex-column">
            <span class="font-9 weight-400 color-cinza">Empresa</span>
            <span class="font-10 weight-700 color-cinza">{{ documentoSelecionado.empresa }}</span>
          </div>

          <div class="flex-column">
            <span class="font-9 weight-400 color-cinza">Usuário Envio</span>
            <span class="font-10 weight-700 color-cinza">{{ documentoSelecionado.usuarioEnvio }}</span>
          </div>

          <div class="flex-column">
            <span class="font-9 weight-400 color-cinza">Data</span>
            <span class="font-10 weight-700 color-cinza">{{ documentoSelecionado.data | date: 'dd/MM/yyyy - HH:mm' }}</span>
          </div>

          <div class="flex-column">
            <span class="font-9 weight-400 color-cinza">Periodicidade</span>
            <span class="font-10 weight-700 color-cinza">{{ documentoSelecionado.periodicidade }}</span>
          </div>
        </div>

        @if (documentoSelecionado.extensaoArquivo.includes('pdf')) {
          <iframe [src]="documentoSelecionado.urlArquivo"></iframe>
        } @else {
          <div class="flex-column gap-10" style="width: 50%;">
            <div class="flex-row align-center gap-5 cursor-pointer" (click)="baixarArquivo()">
              <mat-icon>description</mat-icon>
              <span class="font-11">{{ documentoSelecionado.nomeArquivo }}.{{ documentoSelecionado.extensaoArquivo }}</span>
            </div>
            <div class="flex-column center-center gap-10">
              <mat-icon class="material-icons-outlined" style="font-size: 120px; height: auto; width: auto">visibility_off</mat-icon>
              <span class="weight-600 color-azul" style="font-size: 20px; text-align: center">Visualização do arquivo enviado indisponível.</span>
            </div>
          </div>
        }

        <img class="log" src="../../../assets/icone/log.svg" (click)="mostrarLogsDocumento(documentoSelecionado)" />
      </div>
    } @else if (width > 1024) {
      <div class="flex-row center-center" style="width: 100%">
        <span class="weight-600 color-azul" style="font-size: 32px">Selecione um documento para visualizar.</span>
      </div>
    }
  </div>
</div>
